__webpack_require__.p = "/hamada-assi-project1-react/";